<template>
  <div class="zon">
    <van-overlay :show="loading">
      <div class="wrapper">
        <van-loading type="spinner" />
      </div>
    </van-overlay>

    <div v-if="!loading">
      <div class="new-div-by"></div>
      <ul
        class="div-by"
        :class="info.isCanCancelSaleAfter == 'y' || info.status == 'USER_SEND_GOODS_ING' ? 'mar-100': ''"
      >
        <li class="li1">
          <van-row>
            <van-col span="4">
              <!-- <van-icon name="todo-list" size="50" :color="$theme.u_main_color_btn_bg" /> -->
              <img v-if="info.status == 'FINISH'" src="@/assets/image/detail_print@2x.png" alt="" class="img-icon">
              <img v-else-if="info.status == 'SALE_AFTER_REJECT' || info.status == 'ALREADY_CANCEL'" src="@/assets/image/detail_close@2x.png" alt="" class="img-icon">
              <img v-else-if="info.status == 'WAIT_CHECK'" src="@/assets/image/detail_wait-print@2x.png" alt="" class="img-icon">
              <img v-else src="@/assets/image/detail_wait-print@2x.png" alt="" class="img-icon">
            </van-col>
            <van-col span="19" class="f32">{{info.showStatus}}</van-col>
          </van-row>
        </li>
        <li v-if="stepVisible">
          <DetailF2Comp :aftype="info.afterSaleType" :aftypeN="info.afterSaleTypeDisplayName" :afnode="info.afterFlowNode"></DetailF2Comp>
        </li>
        <li>
          <DetailFComp :steps="info.checkFlowList" :stepsRow="info"></DetailFComp>
        </li> 
        <li v-if="info.status == 'USER_SEND_GOODS_ING'">
          <DetailCComp
            :showBackText="true"
            :addressInfo="{userName: info.returnUserName, mobile: info.returnMobile, adress: info.address}"
          ></DetailCComp>
        </li>
        <!-- <li>
          <div class="div-mia">
            <ul>
              <li style="margin-bottom:0;">
                <van-row>
                  <van-col span="8">{{radio3Boolean[info.afterSaleType] || '退款总金额'}}</van-col>
                  <van-col span="16" class="rig red">￥{{info.actualRefundPrice ? info.actualRefundPrice :info.checkPrice? info.checkPrice: info.lastRefundPrice}}</van-col> 
                </van-row>
              </li>
            </ul>
          </div>
        </li> -->
        <li class="coupon_code" v-if="info.itemVO && info.itemVO.length > 0 &&  info.itemVO[0].couponCodeVo">
          <div class="coupon_code_title" @click="test">
            <div class="title_l">券码信息</div>
            <div class="title_r">{{ info.itemVO[0].couponCodeVo.isRefunded ? '已退款' : '' }}</div>
          </div>
          <div class="coupon_code_body">{{ info.itemVO[0].couponCodeVo.couponCode }}</div>
        </li>
        <!-- <li>
          <DetailGComp :imgs="info.itemVO" :orderDetails="info" role="user"></DetailGComp>
        </li> -->
        <li>
          <div class="div-mia">
            <ul>
              <li>
                <van-row type="flex" justify="start" align="center">
                  <van-col span="21">
                    <span class="w60">售后单号: </span>
                    <span>{{info.returnCode}}</span>
                  </van-col>
                  <!-- <van-col span="" class="rig">{{info.returnCode}}</van-col> -->
                  <van-col span="3" class="rig" @click="copyFun(info.returnCode + '')">
                    <van-tag plain type="warning" style="padding-top:2px">复制</van-tag>
                  </van-col>
                </van-row>
              </li>
              <li>
                <van-row type="flex" justify="end" align="center">
                  <van-col span="21" >
                     <span class="w60">订单号: </span>
                    <span>{{info.orderId || info.subOrderCode}}</span>
                  </van-col>
                  <!-- <van-col span="13" class="rig">{{info.orderId || info.subOrderCode}}</van-col> -->
                  <van-col
                    v-if="info.orderId"
                    span="3"
                    class="rig"
                    @click="copyFun(info.orderId + '')"
                  >
                    <van-tag plain type="warning" style="padding-top:2px">复制</van-tag>
                  </van-col>
                  <van-col
                    v-if="info.subOrderCode"
                    span="3"
                    class="rig"
                    @click="copyFun(info.subOrderCode + '')"
                  >
                    <van-tag plain type="warning" style="padding-top:2px">复制</van-tag>
                  </van-col>
                </van-row>
              </li>
              <li>
                <van-row>
                   <van-col span="24">
                     <span class="w60">申请时间: </span>
                    <span>{{info.applyTime}}</span>
                  </van-col>
                  <!-- <van-col span="24">: </van-col> -->
                  <!-- <van-col span="13" class="rig">{{info.applyTime}}</van-col> -->
                </van-row>
              </li>
              <li>
                <van-row>
                   <van-col span="24">
                     <span class="w60">售后类型: </span>
                    <span>{{info.afterSaleTypeDisplayName}}</span>
                  </van-col>
                  <!-- <van-col span="">: </van-col> -->
                  <!-- <van-col span="13" class="rig">{{info.afterSaleTypeDisplayName}}</van-col> -->
                </van-row>
              </li>
              <li>
                <van-row>
                  <van-col span="24">
                     <span class="w60">订单状态: </span>
                    <span>{{info.statusDisplayName}}</span>
                  </van-col>
                  <!-- <van-col span="24">订单状态: {{info.showStatus || info.orderStatus}}</van-col> -->
                  <!-- <van-col span="13" class="rig">{{info.showStatus || info.orderStatus}}</van-col> -->
                </van-row>
              </li>
              <li>
                <van-row>
                  <van-col span="24">
                     <span class="w60">{{info.afterSaleTypeDisplayName + '原因'}}: </span>
                    <span>{{info.reason}}</span>
                  </van-col>

                </van-row>
              </li>

              <li v-if="info.afterSaleType != 'CHANGE_PRODUCT'">
                <van-row>
                  <van-col span="24">
                     <span class="w60">{{info.afterSaleTypeDisplayName + '总额'}}: </span>
                    <span class="money" v-price="info.actualRefundPrice ? info.actualRefundPrice :info.checkPrice? info.checkPrice: info.lastRefundPrice"></span>
                  </van-col>

                </van-row>
              </li>
              <li v-if="info.afterSaleType == 'CHANGE_PRODUCT'">
                <van-row>
                  <van-col span="24">
                     <span class="w60">{{info.afterSaleTypeDisplayName +  '总数'}}: </span>
                    <span class="money"> x{{info.count}}</span>
                  </van-col>
                </van-row>
              </li>


              <li>
                <van-row>
                  <van-col span="24">
                     <span class="w60">{{info.afterSaleTypeDisplayName +  '说明'}}: </span>
                    <span> {{info.remark}}</span>
                  </van-col>
                  <!-- <van-col span="24">问题描述: {{info.remark}}</van-col> -->
                  <!-- <van-col span="13" class="rig">{{info.remark}}</van-col> -->
                </van-row>
              </li>
            </ul>
            <van-row v-if="info.imageInfoListUser && info.imageInfoListUser.length > 0">
              <van-col span="4">图片凭证</van-col>
              <van-col span="20">
                <van-grid :border="false" :column-num="3">
                  <van-grid-item v-for="(item,index) in info.imageInfoListUser" :key="index">
                    <van-image
                      height="70"
                      width="70"
                      :src="item.imageUrl"
                      @click="showMaxImgFun([item.imageUrl])"
                    />
                  </van-grid-item>
                </van-grid>
              </van-col>
            </van-row>        
          </div>
        </li>

        <li  v-if="info.itemVO.length > 0  &&  info.afterSaleType != 'JUST_FREIGHT'">
          <div class="div-mia">
            <div class="after_titlc">售后商品</div>
            <div class="after_goods_list" v-for="(item,index) in info.itemVO" :key="index">
              <div class="after_good">
                  <div class="img">
                    <img :src="item.skuImageKey">
                  </div>
                  <div class="info">
                    <div class="info_good">
                      <span>{{item.goodsName}}</span>
                      <span class="money"  v-price="item.goodsPrice"></span>
                    </div>
                    <div class="info_sku">
                      <span style="flex:1">{{item.attributeValues}}</span>
                      <span>X{{item.goodsCount}}</span>
                    </div>
                  </div>
              </div>
              <div class="sales">售后金额：<span class="money" v-price="item.saleAfterPrice"></span> </div>
            </div>
           
          </div>
        </li>
      </ul>

      <div class=""></div>

      <div class="div-dib navbar-fixed">
        <div class="contact"><ContactComp class="mar-30" role="user" :contactId="info.branchId" :isVirtual="info.itemVO.length > 0 ? info.itemVO[0].isVirtual:''"></ContactComp></div>
        <CancelAfterComp
          v-if="info.isCanCancelSaleAfter == 'y'"
          :afterId="afterId || $route.query.afterId"
          :subId="info.subOrderId"
          :afterSaleType="info.afterSaleType"
          @callbackFun="init"
          class="mar-30"
        ></CancelAfterComp>
        <div><van-button size="mini" v-if="info.afterSaleType != 'CHANGE_PRODUCT' && info.status == 'USER_SEND_GOODS_ING'" class="yel mar-30" @click="yesVisible = true" round>填写物流单</van-button></div>
        <div><van-button size="mini" v-if="!radioBoolean[info.afterSaleType] && info.userExpressEnable == 'y' && info.userExpressEnable == 'y' && !info.expressCompany && !info.expressNo" class="mar-30 wt yel" @click="yesVisibleFun('add')" round>寄货</van-button></div>
        <div><van-button size="mini" v-if="!radioBoolean[info.afterSaleType] && info.userExpressEnable == 'y' && info.expressCompany && info.expressNo" class="yel mar-30" @click="yesVisibleFun('editor')" round>修改寄货</van-button></div>
        <div><van-button size="mini" v-if="!radioBoolean[info.afterSaleType] && info.branchRejectReason" class="wt" @click="rejectInfoVisible = true" round>拒绝原因</van-button></div>
        <div><van-button size="mini" v-if="!radioBoolean[info.afterSaleType] && info.branchRejectReason" class="wt mar-30" @click="goCallFun" round>平台介入</van-button></div>
        <div><van-button size="mini" :loading="finishLoading" v-if="info.status == 'RETURN_GOODS_ING' && info.branchSendExpresscompany && info.branchSendExpressno" @click="fininAfterFun" class="wt mar-30" round >完成售后</van-button></div>
        <div><van-button size="mini" :loading="finishLoading"  @click="urgeOrderAfterFun" class="wt mar-30" :class="{'clearBtn':info.haveUrgeButton==2}" round v-if="info.haveUrgeButton">催售后</van-button></div>
      </div>

      <van-overlay z-index="100" :show="yesVisible" @click="yesVisible = false">
        <div class="wrapper" @click.stop>
          <div class="block">
            <div class="block-div">
              <h5 class="text">快递公司</h5>
              <div class="content">
                <van-field
                  class="bor"
                  type="text"
                  v-model="sendGoogForm.expressCompany"
                  placeholder="请输入快递公司"
                />
                <h5 class="text mat-10">物流单号</h5>
                <van-field
                  class="bor"
                  type="text"
                  v-model="sendGoogForm.expressNo"
                  placeholder="请输入物流单号"
                />
              </div>
            </div>
            <van-button class="btn" type="default" @click="yesVisible = false">取消</van-button>
            <van-button
              :loading="yesLoading"
              class="btn yel-b"
              type="default"
              @click="checkYesFun"
            >确认</van-button>
          </div>
        </div>
      </van-overlay>

      <van-popup round v-model="rejectInfoVisible" closeable position="bottom" @close="rejectInfoVisible = false">
        <RejectInfo role="user" @closeModal="rejectInfoVisible = false" @callbackShowMaxImgFun="showMaxImgFun" :rejectInfo="info"/>
      </van-popup>
    </div>
  </div>
</template>
<script>
import http from "@/utils/axios";
import Util from "@/utils/common";
import DetailAComp from "./components/detailA";
import DetailFComp from "./components/detailF";
import DetailF2Comp from "./components/detailF2";
import DetailGComp from "./components/detailG";
import CancelAfterComp from "./components/cancelAfterComp";
import DetailCComp from "./components/detailC";
import ContactComp from "./components/contactComp";
import { Toast } from "vant";
import RejectInfo from '@/views/beeorder/components/rejectInfo'
import Images from '../activities/floors/ad-images/images.vue';
import steps from "./components/steps";
export default {
  data() {
    return {
      afterId: this.$route.query.afterId || "",
      loading: true,
      info: {
        mainOrderLabel: "",
        lastRefundPrice: "",
        frightPrice: "",
        goodPrice: "",
        checkFlowList: [],
        itemVO: [],
        voucherImgKeys: [],
        imageInfoList: []
      },
      showCancelBtn: false,
      yesVisible: false,
      sendGoogForm: {
        afterId: "",
        expressCompany: "",
        expressNo: ""
      },
      yesLoading: false,
      radioFormat:{
        'JUST_PRODUCT': '退款原因',
        'JUST_MONEY': '仅退款原因',
        'CHANGE_PRODUCT': '换货原因',
      },
      radioBoolean:{
        'JUST_PRODUCT': true,
        'JUST_MONEY': true,
        'CHANGE_PRODUCT': false,
      },
      radio3Boolean:{
        'JUST_PRODUCT': '退款总金额',
        'JUST_MONEY': '退款总金额',
        'CHANGE_PRODUCT': '换货总金额',
      },
      radio4Boolean:{
        'JUST_PRODUCT': '问题描述',
        'JUST_MONEY': '问题描述',
        'CHANGE_PRODUCT': '换货说明',
      },
      rejectInfoVisible: false,
      finishLoading: false,
      stepArray:["步骤1", "步骤2", "步骤3", "步骤4", "步骤5","步骤4", "步骤5"]

    };
  },
  methods: {
    test() {
      console.log(this.info, 777);
    },
    init() {
      this.loading = true;
      let param = {
        appType: "",
        id: this.afterId,
        pageNum: 0,
        pageSize: 0
      };
      http({
        url: "order/app/newafter/detail",
        method: "post",
        parmes: param
      }).then(rps => {
        this.loading = false;
        this.info = rps.data;
        console.log(this.info, 111);
      });
    },
    copyFun(code) {
      Util.copyText(code);
    },
    urgeOrderAfterFun(){
      if(this.info.haveUrgeButton ==2){
        return this.$toast('我们已经将您的请求告知店铺，还请您耐心等待');
      }
      this.http({
        url:'order/urge/urgeOrderAfter',
        method:'post',
        parmes:{
          afterOrderId:this.afterId
        }
      }).then(rps=>{
        if(rps.code ==200){
          this.$toast(rps.data);
          return;
        }
      })
    },
    oldAfterDetailLink(orderId) {
      http({
        url: "order/app/newafter/oldersaledata/detail/" + orderId,
        method: "get"
      })
        .then(rps => {
          if (this.$route.query.type == "bees") {
            this.$router.replace({
              path: "/beeafterorderDetail",
              query: { afterId: rps.data.afterId }
            });
          } else {
            this.afterId = rps.data.afterId;
            this.init();
          }
        })
        .catch(rps => {});
    },
    checkYesFun() {
      if (!this.sendGoogForm.expressCompany.replace(/\s/g, "")) {
        Toast("物流公司不能为空");
        return;
      }
      if (!this.sendGoogForm.expressNo.replace(/\s/g, "")) {
        Toast("物流单号不能为空");
        return;
      }
      let reg = /^[0-9a-zA-Z]+$/;
      if (!reg.test(this.sendGoogForm.expressNo)) {
        Toast("请填写真确的物流单号");
        return;
      }
      this.doYesFun();
    },
    doYesFun() {
      this.sendGoogForm.afterId = this.afterId;
      this.yesLoading = true;
      http({
        url: "order/app/newafter/sendGoods",
        method: "post",
        parmes: this.sendGoogForm
      }).then(rps => {
        this.yesLoading = false;
        Toast(rps.message || "待卖家收货");
        this.yesVisible = false;
        this.init();
      });
    },
    showMaxImgFun(imgs) {
      Util.showMaxImg(encodeURIComponent(JSON.stringify(imgs)), 0);
    },
    yesVisibleFun(editor=null){
      // this.yesVisible = true
      let options = {
        afterId:this.info.id,
        changeProductRemark: this.info.changeProductRemark || '',
        address: this.info.address || '',
        returnMobile: this.info.returnMobile || '',
        returnUserName: this.info.returnUserName || '',
        afterSaleType: this.info.afterSaleType,
        status: this.info.status,
        expressCompany: this.info.expressCompany || '',
        expressNo: this.info.expressNo || '',
        editor: editor
      }
      this.$store.dispatch('setUserAfterSaleSureAddressData',options)
      this.$router.push({ name: "userAfterSaleSureAddress"});
    },
    fininAfterFun(){
      this.finishLoading = true
      http({
        url: "order/app/newafter/userConfirmFinish",
        method: "post",
        parmes: {isPass: 'y', afterId: this.info.id}
      }).then(rps => {
        this.$toast(rps.message || '成功')
        this.finishLoading = false
        this.init()
      });
    },
    goCallFun(){
      Util.nativeMethod({tm:'4080100',tp:{}})
    }
  },
  created() {
    if (this.$route.query.targetParams) {
      let target = JSON.parse(this.$route.query.targetParams);
      this.afterId = (target.afterId && target.afterId) || "";
      this.init();
    }
    if (this.$route.query.orderId) {
      this.oldAfterDetailLink(this.$route.query.orderId);
    }
    if (this.$route.query.afterId) {
      this.init();
    }
    this.$loading.hide();
    Util.nativeMethod({tm:'4000102',tp:{pageType_pvar:'售后'}})
    Util.nativeMethod({tm:'4000102',tp:{pageName_pvar:document.title}})
  },
  components: {
    DetailAComp,
    DetailFComp,
    DetailF2Comp,
    DetailGComp,
    CancelAfterComp,
    DetailCComp,
    ContactComp,
    RejectInfo,
    Images,
    steps
  },
  computed: {
    stepVisible() {
      if(['售后关闭','售后取消'].includes(this.info.showStatus)){
        return false;
      }else{
        if(['仅退款','退货退款','换货','子订单(仅退款)'].includes(this.info.afterSaleTypeDisplayName)){
          return true;
        }else{
          return false;
        }
      }
    }
  },
};
</script>
<style lang="less" scoped>
.after_goods_list:not(:last-child){
  border-bottom:1rpx solid #E1E1E1 ;
}

.after_titlc{
  font-size: 26px;
  font-weight: 600;
  color: #333333;
  margin-bottom: 30px;
}
.sales{
  text-align: right;
  padding-top: 10px;
  font-size: 28px;
  padding-bottom: 30px;
}
.money{
        color:#ED3939;
      }
.after_good{
  display: flex;
  align-items: center;
  img{
   width: 180px;
   height: 180px;
   border-radius: 16px ;
  }
  .info{
    display: flex;
    align-content: center;
    flex-direction: column;
    flex: 1;
    padding-left: 20px;
    height: 180px;
    .info_good :first-child{
      padding-bottom: 44px;
      font-size: 28px;
    }
    
    .info_good{
      display: flex;
      align-content: center;
      justify-content: space-between;
 

     
    }
    .info_sku{
      font-size: 24px;
      color: #898887;
      display: flex;
      justify-content: space-between;
    }
  }

}
.wrapper {
  display: flex;
  align-items: center;
  justify-content: center;
  height: 100%;
}
.zon {
  position: relative;
  .new-div-by {
    height: 124px;
    width: 100%;
    background-color: var(--buttonColor);
  }
}
.div-by {
  width: 90%;
  margin-top: -86px;
  margin-left: 5%;
  font-size: 0.4rem;
  margin-bottom: 130px;
  li {
    margin-bottom: 20px;
  }
  .li1 {
    height: 100px;
    line-height: 100px;
    border-radius: 0.15rem;
    background-color: #fff;
    padding: 20px 20px;
    .f32 {
      font-size: 32px;
      color: #333333;
      font-weight: bold;
    }
  }
  .coupon_code {
    // height: 120px;
    border-radius: 0.15rem;
    background-color: #fff;
    padding: 30px 20px;
    .coupon_code_title {
      display: flex;
      justify-content: space-between;
      margin-bottom: 20px;
      .title_l {
        font-size: 24px;
        font-weight: 500;
        color: #333333;
      }
      .title_r {
        font-size: 24px;
        font-weight: 500;
        color: #ED3939;
      }
    }
    .coupon_code_body {
      font-size: 28px;
      font-weight: 500;
      color: #333333;
      text-decoration:line-through;
    }
  }
}
.mar-100 {
  margin-bottom: 120px;
}
.div-mia {
  font-size: 0.3rem;
  border-radius: 0.15rem;
  background-color: #fff;
  padding: 40px;
  text-align: left;
  .van-col--21,.van-col--24{
    display: flex;
    justify-content: space-between;
  }
  .w60{
    // width: 150px;
    display: inline-block;
    color:#808080 ;
  }
}
.div-dib {
  width: 100%;
  background-color: #fff;
  // padding-top: 10px;
  padding-bottom: 10px;
  display: flex;
  justify-content: flex-end;
  .contact {
    button[normal] {
      width: 160px;
      height: 60px;
      border: 1PX solid #999999;
      color: #999999;
      &::after {
        border-width: 0;
      }
    }
  }
}
.rig {
  text-align: right;
}
.navbar-fixed {
  width: 96%;
  padding-right: 4%;
  position: fixed;
  left: 0;
  bottom: 0;
  background: #fff;
  z-index: 3;
  border-top: 1PX solid #fafafa;
}
.clearBtn{
  background: #ccc !important;
  color: #999 !important;
}
.block {
  width: 80%;
  background-color: #fff;
  border-radius: 0.2rem;

  .btn {
    width: 50%;
    height: 100px;
    line-height: 100px;
  }
  .block-div {
    padding-left: 50px;
    padding-right: 50px;
    padding-top: 41px;
    /deep/.van-field__body > input {
      border: 1px solid #f2f2f2;
      height: 64px;
      line-height: 64px;
    }
  }
  .content {
    display: block;
    align-items: center;
    justify-content: center;
    .bor {
      padding: 0.26525rem 0;
      margin-bottom: 15px;
    }
    .img_up {
      margin-bottom: 64px;
    }
    .img_up_div {
      position: relative;
      display: inline-block;
      width: 200px;
      height: 200px;
      margin: 5px;
      .close {
        color: red;
        font-weight: bold;
        position: absolute;
        right: 8px;
        font-size: 24px;
      }
    }
    .div-up {
      border: 3px dotted #ccc;
      width: 2rem;
      height: 2rem;
      position: relative;
      .div-up-1 {
        position: absolute;
        top: 30%;
        left: 30%;
      }
    }
  }
  .text {
    font-size: 28px;
  }
  .mat-10 {
    margin-bottom: 20px;
  }
  .yel-b {
    color: #f8a651;
  }
}
/deep/.van-cell:not(:last-child)::after {
  position: absolute;
  box-sizing: border-box;
  content: " ";
  pointer-events: none;
  right: 0;
  bottom: 0;
  left: 0.4244rem;
  border-bottom: 0;
  -webkit-transform: scaleY(0.5);
  transform: scaleY(0.5);
}
.mar-30 {
  margin-right: 10px;
  margin-left: 10px;
}
.yel {
  background: var(--buttonColor) !important;
  height: 0.8rem;
  text-align: center;
  color: var(--textColor) !important;
  border: 0px;
  font-size: 24px;
  border: 1PX solid var(--buttonColor) !important;
}
.wt{
  background: #ffffff;
  height: 0.8rem;
  text-align: center;
  min-width: 160px;
  font-size: 24px;
  border: 0px;
  border: 1PX solid #999999;
  color: #999999;
}
.red {
  color: #ed3939;
}
.van-tag--warning.van-tag--plain{
  color:#F8A651
}
.img-icon{
  width: 100px;
}
</style>